import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import { AppProviders } from "./providers/app-providers";
import { Route, Routes } from "react-router-dom";
import { routes } from "./routes/routes";
import { PageNotFound } from "./pages/PageNotFound/PageNotFound";
import { Dashboard } from "./pages/Dashboard";
import { Marketplace } from "./pages/Marketplace";
import { Bridge } from "./pages/Bridge";
import { Layout } from "./components/Layout";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <AppProviders>
      <Layout>
        <Routes>
          <Route path={"/"} element={<Dashboard />} />
          <Route path={"/marketplace"} element={<Marketplace />} />
          <Route path={"/bridge"} element={<Bridge />} />
          {routes.map((route) => (
            <Route
              path={route.path}
              key={`route-key-'${route.path}`}
              element={<route.component />}
            />
          ))}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Layout>
    </AppProviders>
  </BrowserRouter>
);
